"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeValue = void 0;
function getSizeValue(_a) {
    var size = _a.size, sizes = _a.sizes, _b = _a.defaultSize, defaultSize = _b === void 0 ? 'md' : _b;
    if (typeof size === 'number') {
        return size;
    }
    return sizes[size] || size || sizes[defaultSize];
}
exports.getSizeValue = getSizeValue;
